import axios from 'axios';

const getFeedback = (solicitacaoId) => axios.get(`/fornecedor/solicitacoes-respostas/${solicitacaoId}/sinalizadores`);

export default {
  getFeedback,
};
